import React, { useState } from "react";
import ModuleGuide from "./ModuleGuide";
import Glossary from "./Glossary";


function TrainingModule() {
  return (
    <>
        <ModuleGuide />
        <Glossary />
        {/* <DataSubmissionProcess />
        <BalancingGrid />
        <AdditionalFeatures /> */}
    </>
  );
}

export default TrainingModule;
